import { render } from "./AppUserMenu.vue?vue&type=template&id=1bf25c80"
import script from "./AppUserMenu.vue?vue&type=script&lang=js"
export * from "./AppUserMenu.vue?vue&type=script&lang=js"

import exportComponent from "/data/vstsagent01/user/2766/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/project/ui/menu/AppUserMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1bf25c80"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1bf25c80', __exports__)) {
    console.log('reload')
    api.reload('1bf25c80', __exports__)
  }
  
  module.hot.accept("./AppUserMenu.vue?vue&type=template&id=1bf25c80", () => {
    console.log('re-render')
    api.rerender('1bf25c80', render)
  })

}


export default __exports__